import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Tabs, Tab } from 'react-bootstrap';

import SchedulesTab from './Elements/SchedulesTab';
import SchedulesGroupingsTab from './Elements/SchedulesGroupingsTab';
import SchedulesVacationsTab from './Elements/SchedulesVacationsTab';
import SchedulesAircraftsTab from './Elements/SchedulesAircraftsTab';
import ScheduleStaffsTab from './Elements/ScheduleStaffsTab';
import ScheduleBudgetTab from './Elements/ScheduleBudgetTab';
import SchedulesStaffCountTab from './Elements/SchedulesStaffCountTab';
import SchedulesStaffDifferenceTab from './Elements/SchedulesStaffDifferenceTab';
import SchedulesComments from './Elements/SchedulesComments';


class SchedulesUnified extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      schedule_grade_group_staff_vacations: [],
      schedule_grade_aircrafts: [],
      data_calculate_sga: [],
      data_calculate_sggs: [],
      data_calculate_sga_total_bases: [],
      data_calculate_sggs_total_bases: [],
      data_calculate_to_schedules_total_staffs_by_day: [],
      schedule_grade_group_staffs: [],
      schedule_grade_base_settings: [],
      data_schedule_grade_comments: [],
      data_calculate_to_schedules_total_staff_differences: [],
      data_calculate_to_schedules_total_staff_differences_group: [],
      data_calculate_to_schedules_total_staffs_by_role_day: [],
      data_calculate_to_schedules_total_staffs_by_group: [],
      schedule_grades: [],
      sg_ids: [],
      data_schedule_grade_groupings: [],
      schedule_days: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadTabsUpdated = this.loadTabsUpdated.bind(this);
    this.updateData = this.updateData.bind(this);
    this.loadData = this.loadData.bind(this);
    this.loadTabs = this.loadTabs.bind(this);
    this.addDataBase = this.addDataBase.bind(this);
    this.exportCsv = this.exportCsv.bind(this);
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData(1));
    }
  }

  updateData (responseJson) {
    this.setState({updated: 1}, this.loadTabsUpdated(responseJson));
  }

  loadTabs(value) {
    this.handleAlert('', '', 'open');
    if (value) {
      this.setState({sg_ids: value, updated: 1});
      var datasave = {
        schedule_grade_ids: value,
        month: this.props.match.params.month,
        year: this.props.match.params.year,
      };
    } else {
      var datasave = {
        schedule_grade_ids: this.state.sg_ids,
        month: this.props.match.params.month,
        year: this.props.match.params.year,
      };
    }
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escalas/unificadas/info', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({planning_vacation_staffs: responseJson.data.planning_vacation_staffs});
            self.setState({planning_vacation_staffs_total: responseJson.data.planning_vacation_staffs_total});
            self.setState({schedule_grade_group_staff_vacations: responseJson.data.schedule_grade_group_staff_vacations});
            self.setState({data_schedule_grade_groupings: responseJson.data.schedule_grade_groupings});
            self.setState({schedule_grade_aircrafts: responseJson.data.schedule_grade_aircrafts});
            self.setState({data_calculate_sga: responseJson.data.data_calculate_sga});
            self.setState({data_calculate_sga_total_bases: responseJson.data.data_calculate_sga_total_bases});
            self.setState({data_calculate_sggs: responseJson.data.data_calculate_sggs});
            self.setState({data_calculate_sggs_total_bases: responseJson.data.data_calculate_sggs_total_bases});
            self.setState({schedule_grade_group_staffs: responseJson.data.schedule_grade_group_staffs});
            self.setState({schedule_grade_base_settings: responseJson.data.schedule_grade_base_settings});
            self.setState({roles_list: responseJson.data.roles_list});
            self.setState({data_schedule_grade_comments: responseJson.data.data_schedule_grade_comments});
            self.setState({base_setting_groups_select: responseJson.data.base_setting_groups_select});
            self.setState({data_calculate_to_schedules_total_staffs: responseJson.data.data_calculate_to_schedules_total_staffs});
            self.setState({data_calculate_to_schedules_total_staffs_by_group: responseJson.data.data_calculate_to_schedules_total_staffs_by_group});
            self.setState({data_calculate_to_schedules_total_staffs_by_day: responseJson.data.data_calculate_to_schedules_total_staffs_by_day});
            self.setState({data_calculate_to_schedules_total_staffs_by_role_day: responseJson.data.data_calculate_to_schedules_total_staffs_by_role_day});
            self.setState({schedule_days: responseJson.data.schedule_days});
            self.setState({overlay: {message: '', type: '', status: 'closed'}});
          } else{
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
      });
    });
  }

  loadTabsUpdated(event) {
    this.handleAlert('', '', 'open');

    var datasave = {
      schedule_grade_ids: this.state.sg_ids,
      month: this.props.match.params.month,
      year: this.props.match.params.year,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escalas/unificadas/info', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({planning_vacation_staffs: responseJson.data.planning_vacation_staffs});
            self.setState({planning_vacation_staffs_total: responseJson.data.planning_vacation_staffs_total});
            self.setState({schedule_grade_group_staff_vacations: responseJson.data.schedule_grade_group_staff_vacations});
            self.setState({data_schedule_grade_groupings: responseJson.data.schedule_grade_groupings});
            self.setState({schedule_grade_aircrafts: responseJson.data.schedule_grade_aircrafts});
            self.setState({data_calculate_sga: responseJson.data.data_calculate_sga});
            self.setState({data_calculate_sga_total_bases: responseJson.data.data_calculate_sga_total_bases});
            self.setState({data_calculate_sggs: responseJson.data.data_calculate_sggs});
            self.setState({data_calculate_sggs_total_bases: responseJson.data.data_calculate_sggs_total_bases});
            self.setState({schedule_grade_group_staffs: responseJson.data.schedule_grade_group_staffs});
            self.setState({schedule_grade_base_settings: responseJson.data.schedule_grade_base_settings});
            self.setState({roles_list: responseJson.data.roles_list});
            self.setState({data_schedule_grade_comments: responseJson.data.data_schedule_grade_comments});
            self.setState({base_setting_groups_select: responseJson.data.base_setting_groups_select});
            self.setState({data_calculate_to_schedules_total_staffs: responseJson.data.data_calculate_to_schedules_total_staffs});
            self.setState({data_calculate_to_schedules_total_staffs_by_group: responseJson.data.data_calculate_to_schedules_total_staffs_by_group});
            self.setState({data_calculate_to_schedules_total_staffs_by_day: responseJson.data.data_calculate_to_schedules_total_staffs_by_day});
            self.setState({data_calculate_to_schedules_total_staffs_by_role_day: responseJson.data.data_calculate_to_schedules_total_staffs_by_role_day});
            self.setState({schedule_days: responseJson.data.schedule_days});
          }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (self.state.updated == 1) {
          self.handleAlert(event.message, event.status, 'open');
          self.setState({updated: 0});
        } else {
          self.handleMessage();
        }
      });
    });
  }

  loadData (event) {
    var self = this;
    var base_id = 0;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escalas/unificadas/info/'+self.props.match.params.month+ '/' + self.props.match.params.year;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/escalas');
        if (responseJson.status === 'success') {
          self.setState({schedule_grades: responseJson.data.schedule_grades});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }

  addDataBase(value) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    self.setState({date: value});
    var datasave = {
      date: value,
      schedule_grade_ids: this.state.sg_ids,
      month: self.props.match.params.month,
      year: self.props.match.params.year,
    };
    self.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/unificada/diferencas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data_calculate_to_schedules_total_staff_differences: responseJson.data.data_calculate_to_schedules_total_staff_differences});
          self.setState({data_calculate_to_schedules_total_staff_differences_group: responseJson.data.data_calculate_to_schedules_total_staff_differences_group});
          self.setState({data_calculate_to_schedules_total_staffs_by_group: responseJson.data.data_calculate_to_schedules_total_staffs_by_group});
          self.setState({schedule_days: responseJson.data.schedule_days});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  exportCsv(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var datasave = {
      date: self.state.date,
      schedule_grade_ids: self.state.sg_ids,
      month: self.props.match.params.month,
      year: self.props.match.params.year,
    };
    self.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/escala/unificada/dados/padroes', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Escalas Unificadas - {self.props.match.params.month+ '/' + self.props.match.params.year}</h3>
      <Link to="/escalas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <button className="btn btn-success pull-right" value={this.state.data} onClick={this.exportCsv}>
        <i className="fa fa-fw fa-table"></i> Dados Padrões
      </button>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={self.state.key} onSelect={self.handleNavTab.bind(self, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title="Seleção de escala">
          <SchedulesTab schedule_grades={self.state.schedule_grades} loadTabs={self.loadTabs} handleAlert={self.handleAlert}/>
        </Tab>
        <Tab eventKey={2} title="Agrupamentos">
          <SchedulesGroupingsTab data_schedule_grade_groupings={self.state.data_schedule_grade_groupings} roles_list={self.state.roles_list} sg_ids={self.state.sg_ids} handleAlert={self.handleAlert} updated={self.state.updated} updateData={self.updateData}/>
        </Tab>
        <Tab eventKey={3} title="Férias">
          <SchedulesVacationsTab handleAlert={self.handleAlert} sg_ids={self.state.sg_ids} schedule_grade_group_staff_vacations={self.state.schedule_grade_group_staff_vacations} planning_vacation_staffs={self.state.planning_vacation_staffs} planning_vacation_staffs_total={self.state.planning_vacation_staffs_total} />
        </Tab>
        <Tab eventKey={4} title="Aeronaves">
          <SchedulesAircraftsTab schedule_grade_aircrafts={self.state.schedule_grade_aircrafts} data_calculate_sga={self.state.data_calculate_sga} data_calculate_sga_total_bases={self.state.data_calculate_sga_total_bases} />
        </Tab>
        <Tab eventKey={5} title="Colaboradores">
          <ScheduleStaffsTab handleAlert={self.handleAlert} sg_ids={self.state.sg_ids} schedule_grade_group_staffs={self.state.schedule_grade_group_staffs} data_calculate_sggs={self.state.data_calculate_sggs} data_calculate_sggs_total_bases={self.state.data_calculate_sggs_total_bases} data_calculate_to_schedules_total_staffs={self.state.data_calculate_to_schedules_total_staffs}/>
        </Tab>
        <Tab eventKey={6} title="Orçamento">
          <ScheduleBudgetTab loadTabs={self.loadTabs} schedule_grade_base_settings={self.state.schedule_grade_base_settings} roles_list={self.state.roles_list} base_setting_groups_select={self.state.base_setting_groups_select}/>
        </Tab>
        <Tab eventKey={7} title="Escalas">
          <SchedulesStaffCountTab schedule_days={self.state.schedule_days} data_calculate_to_schedules_total_staffs_by_role_day={self.state.data_calculate_to_schedules_total_staffs_by_role_day} data_calculate_to_schedules_total_staffs_by_group={self.state.data_calculate_to_schedules_total_staffs_by_group} data_calculate_to_schedules_total_staffs_by_day={self.state.data_calculate_to_schedules_total_staffs_by_day}/>
        </Tab>
        <Tab eventKey={8} title="Diferenças">
          <SchedulesStaffDifferenceTab addDataBase={self.addDataBase} data_calculate_to_schedules_total_staff_differences={self.state.data_calculate_to_schedules_total_staff_differences} data_calculate_to_schedules_total_staff_differences_group={self.state.data_calculate_to_schedules_total_staff_differences_group}/>
        </Tab>
        <Tab eventKey={9} title="Comentários">
          <SchedulesComments data_schedule_grade_comments={self.state.data_schedule_grade_comments} />
        </Tab>
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default SchedulesUnified;



// WEBPACK FOOTER //
// ./src/Components/Schedules/SchedulesUnified.js